import React from "react";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default ({ name, icon }) => {
  return (
    <div className="submit">
      <button type="submit">
        <span>
          {icon && <FontAwesomeIcon icon={icon} size="lg" />}
          <span>{name}</span>
        </span>
      </button>
    </div>
  );
};
